<div class="dialog">
  @if (data.title) {
    <h4 mat-dialog-title>{{data.title}}</h4>
  }
  <div mat-dialog-content>
    <span>{{data.message}}</span>
    @if (data.additionalMessage) {
      <p><i>{{data.additionalMessage}}</i></p>
    }
  </div>
  <div mat-dialog-actions>
    <button class="dialog__button" [mat-dialog-close]="true" cdkFocusInitial>{{ data.yesLabel || 'Yes' }}</button>
    <button class="dialog__button" (click)="onNoClick()">{{ data.noLabel || 'No' }}</button>
  </div>
</div>